import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { publicService } from '../../api/services';

export const fetchDoctors = createAsyncThunk(
  'doctors/fetchAll',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await publicService.getDoctors(params);
      return data;
    } catch (error) {
      return rejectWithValue('Failed to fetch doctors.');
    }
  }
);

export const fetchDoctorById = createAsyncThunk(
  'doctors/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await publicService.getDoctorById(id);
      return data;
    } catch (error) {
      return rejectWithValue('Failed to fetch doctor details.');
    }
  }
);

export const fetchDoctorSlots = createAsyncThunk(
  'doctors/fetchSlots',
  async ({ doctorId, date }, { rejectWithValue }) => {
    try {
      const { data } = await publicService.getDoctorSlots(doctorId, date);
      return data;
    } catch (error) {
      return rejectWithValue('Failed to fetch available slots.');
    }
  }
);

const initialState = {
  doctors: [],
  selectedDoctor: null,
  slots: [],
  loading: false,
  slotsLoading: false,
  error: null,
  filters: {
    search: '',
    specialization: '',
    city: '',
    hospital: '',
    consultation_type: '',
    date: '',
  },
  pagination: {
    page: 1,
    totalPages: 1,
    total: 0,
  },
};

const doctorSlice = createSlice({
  name: 'doctors',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.page = 1;
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
      state.pagination.page = 1;
    },
    setPage: (state, action) => {
      state.pagination.page = action.payload;
    },
    clearSelectedDoctor: (state) => {
      state.selectedDoctor = null;
      state.slots = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDoctors.fulfilled, (state, action) => {
        state.loading = false;
        state.doctors = action.payload.results || action.payload;
        state.pagination.total = action.payload.count || action.payload.length;
        state.pagination.totalPages = Math.ceil(
          (action.payload.count || action.payload.length) / 10
        );
      })
      .addCase(fetchDoctors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDoctorById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDoctorById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedDoctor = action.payload;
      })
      .addCase(fetchDoctorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDoctorSlots.pending, (state) => {
        state.slotsLoading = true;
      })
      .addCase(fetchDoctorSlots.fulfilled, (state, action) => {
        state.slotsLoading = false;
        state.slots = action.payload;
      })
      .addCase(fetchDoctorSlots.rejected, (state, action) => {
        state.slotsLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilters, clearFilters, setPage, clearSelectedDoctor } =
  doctorSlice.actions;
export default doctorSlice.reducer;
